<template>
    <div class="profile__setting profile__setting--edit" style="display: none;">
        <h3>{{ $t("TEXT_EDIT_ACCOUNT") }}</h3>
        <p><span>＊</span>{{ $t("TEXT_REQUIRED_FIELD") }}</p>
        <div class="p-profile-edit__form c-form-parts">
            <dl class="name">
                <dt>{{ $t("LABEL_NAME") }}</dt>
                <dd>
                    <ul class="input-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                        <li v-if="!userStore.isOverseasUser"><input id="edit-input-last-name" type="text"
                                name="last_name" class="plchldr" placeholder="姓" disabled
                                v-model="userStore.editAccountParams.last_name"></li>
                        <li><input id="edit-input-first-name" type="text" name="first_name" class="plchldr"
                                placeholder="名" disabled v-model="userStore.editAccountParams.first_name"></li>
                    </ul>
                    <p class="error-txt">{{ $t("ERROR_INVALID_NAME") }}</p>
                </dd>
            </dl>

            <dl v-if="!userStore.isOverseasUser" class="kana">
                <dt>{{ $t("LABEL_NAME_KANA") }}</dt>
                <dd>
                    <ul class="input-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                        <li><input id="edit-input-last-name-kana" type="text" name="last_name_kana" class="plchldr"
                                placeholder="セイ" disabled v-model="userStore.editAccountParams.last_name_kana"></li>
                        <li><input id="edit-input-first-name-kana" type="text" name="first_name_kana" class="plchldr"
                                placeholder="メイ" disabled v-model="userStore.editAccountParams.first_name_kana"></li>
                    </ul>
                    <p class="error-txt">{{ $t("ERROR_INVALID_NAME_KANA") }}</p>
                </dd>
            </dl>

            <dl class="mailaddress">
                <dt>{{ $t("LABEL_EMAIL") }}</dt>
                <dd>
                    <div class="input-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                        <input id="edit-input-email" type="email" name="email" class="plchldr"
                            :placeholder="$t('LABEL_EMAIL')" disabled v-model="userStore.editAccountParams.email">
                    </div>
                    <p class="error-txt">{{ $t("ERROR_INVALID_EMAIL") }}</p>
                </dd>
            </dl>

            <dl class="sex">
                <dt>{{ $t("LABEL_GENDER") }}</dt>
                <dd>
                    <ul class="radio-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "ul.radio-area" -->
                        <li><input id="edit-input-sex-male" type="radio" name="sex" value="1"
                                v-model="userStore.editAccountParams.sex" disabled checked><label
                                for="edit-input-sex-male"><span>{{ $t("LABEL_MAN") }}</span></label></li>
                        <li><input id="edit-input-sex-female" type="radio" name="sex" value="2" disabled
                                v-model="userStore.editAccountParams.sex"><label for="edit-input-sex-female"><span>{{
                                    $t("LABEL_FEMALE")
                                }}</span></label></li>
                        <li><input id="edit-input-sex-other" type="radio" name="sex" value="3" disabled
                                v-model="userStore.editAccountParams.sex"><label for="edit-input-sex-other"><span>{{
                                    $t("LABEL_OTHER")
                                }}</span></label></li>
                    </ul>
                    <p class="error-txt">{{ $t("LABEL_CHOOSE_SEX") }}</p>
                </dd>
            </dl>

            <dl class="telephone">
                <dt>{{ $t("LABEL_PHONE_NUMBER") }}<span>＊</span></dt>
                <dd>
                    <div class="input-area" :class="{ 'is-error': v$.tel.$error }">
                        <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                        <input id="edit-input-tel" type="tel" name="tel" class="plchldr" placeholder="0300000000"
                            v-model="userStore.editAccountParams.tel" required>
                    </div>
                    <p class="sub-txt">{{ $t("LABEL_NO_HYPHEN") }}</p>
                    <p class="error-txt">{{ v$.tel.$errors[0]?.$message }}</p>
                </dd>
            </dl>

            <dl class="birth">
                <dt>{{ $t("LABEL_BIRTHDATE") }}</dt>
                <dd>
                    <div class="input-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                        <input id="edit-input-birthdate" type="tel" name="birthday" class="plchldr"
                            placeholder="YYYY-MM-DD" pattern="^[0-9\-]+$" disabled maxlength="10"
                            v-model="userStore.editAccountParams.birthday" required>
                    </div>
                    <p class="sub-txt">{{ $t("LABEL_DATE_FORMAT") }}</p>
                    <p class="error-txt">{{ $t("ERROR_BIRTHDATE_REQUIRE") }}</p>
                </dd>
            </dl>

            <dl v-if="userStore.isOverseasUser" class="country">
                <dt>{{ $t("LABEL_COUNTRY") }}<span>＊</span></dt>
                <dd>
                    <div class="select-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "ul.select-area" -->
                        <span class="select-box">
                            <select name="country" id="country" v-model="userStore.editAccountParams.country" required>
                                <option :value="v.id" v-for="(v, i) in userStore.countries" :key="i">{{ v.name }}
                                </option>
                            </select>
                        </span>
                    </div>
                </dd>
            </dl>
            <dl class="zipcode">
                <dt>{{ $t("LABEL_ZIP_CODE") }}<span>＊</span></dt>
                <dd>
                    <div class="input-area" :class="{ 'is-error': v$.zip_code.$error }">
                        <input id="edit-input-zipcode" type="text" name="zip_code" class="plchldr" maxlength="7"
                            @input="userStore.editAccountParams.zip_code = userStore.editAccountParams.zip_code.replace(/\D/g, '')"
                            placeholder="0000000" @keyup="zipCodeChangeInEdit(userStore.editAccountParams.zip_code)"
                            v-model="userStore.editAccountParams.zip_code">
                    </div>
                    <p class="sub-txt">{{ $t("LABEL_ZIP_CODE_OVERSEAS") }}</p>
                    <p class="error-txt">{{ v$.zip_code.$errors[0]?.$message }}</p>
                </dd>
            </dl>

            <dl v-if="!userStore.isOverseasUser" class="address1">
                <dt>{{ $t("LABEL_ADDRESS_1") }}<span>＊</span></dt>
                <dd>
                    <div class="select-area">
                        <!-- TODO: When there is an error, add "is-error" class to this "ul.select-area" -->
                        <span class="select-box">
                            <select name="address_1" id="address_1" v-model="userStore.editAccountParams.address_1"
                                required>
                                <option :value="i" v-for="(v, i) in PREFECTURES_JA">{{ v }}</option>
                            </select>
                        </span>
                    </div>
                    <p class="error-txt">{{ $t('LABEL_SELECT_PREFECTURE') }}</p>
                </dd>
            </dl>

            <dl class="address2">
                <dt>{{ $t("LABEL_ADDRESS_2") }}<span>＊</span></dt>
                <dd>
                    <div class="input-area" :class="{ 'is-error': v$.address_2.$error }">
                        <input id="edit-input-address2" type="text" name="address_2" class="plchldr"
                            :placeholder="$t('LABEL_ADDRESS_2')" v-model="userStore.editAccountParams.address_2">
                    </div>
                    <p class="error-txt">{{ v$.address_2.$errors[0]?.$message }}</p>
                </dd>
            </dl>

            <dl class="address3">
                <dt>{{ $t("LABEL_ADDRESS_3") }}<span>＊</span></dt>
                <dd>
                    <div class="input-area" :class="{ 'is-error': v$.address_3.$error }">
                        <input id="edit-input-address3" type="text" name="address_3" class="plchldr"
                            :placeholder="$t('LABEL_ADDRESS_3')" v-model="userStore.editAccountParams.address_3">
                    </div>
                    <p class="error-txt">{{ v$.address_3.$errors[0]?.$message }}</p>
                </dd>
            </dl>
        </div>

        <div class="p-profile-edit__btn">
            <div class="c-btn c-btn--profedit-submit"><input id="edit-btn-submit" type="button" @click="updateUser()"
                    :value="$t('LABEL_REGISTER_BUTTON')"></div>
            <div class="c-btn c-btn--profedit-cancel"><button @click="resetInputs()" id="edit-btn-cancel">{{
                $t("LABEL_CANCEL") }}</button></div>
        </div>

        <!-- TODO: .is-loading -->
        <div class="c-loader p-profile-edit__loading"><span class="c-loader__icon"></span></div>
    </div>
</template>

<script setup>
import { useUserStore } from "@/stores/userStore";
import { getUpdateUserRules } from "@/validations/userUpdateValidation";
import { useVuelidate } from '@vuelidate/core';
import { profEditClose, stopLoading } from "@/assets/js/entries/main.js";
import { PREFECTURES_JA } from "@/data/constants";
import * as addressUtility from "@/helpers/addressUtility";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const userStore = useUserStore();
const v$ = useVuelidate(getUpdateUserRules(t, userStore), userStore.editAccountParams);

async function resetInputs() {
    await userStore.getAccountInfo();
}

async function updateUser() {
    if (!await v$.value.$validate()) {
        stopLoading();
        return false;
    }
    await userStore.updateAccountInfo();
    await userStore.getAccountInfo();
    userStore.accountUpdateParams = { ...userStore.editAccountParams };
    //Closing edit form
    profEditClose();
}

// Auto-complete address when zip code is changed in edit form
function zipCodeChangeInEdit() {
    if (!userStore.isOverseasUser && userStore.editAccountParams.zip_code !== null && /^\d+$/.test(userStore.editAccountParams.zip_code.toString())) {
        addressUtility.zipCodeAutoComplete(userStore.editAccountParams, userStore.editAccountParams.zip_code.toString());
    }
}
</script>